var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLoggedUserIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_106",
    "data-name": "Group 106",
    transform: "translate(-1260.109 -15.109)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_10",
    "data-name": "Ellipse 10",
    cx: 15,
    cy: 15,
    r: 15,
    transform: "translate(1260.109 15.109)",
    fill: "#4e9a98"
  }), /*#__PURE__*/React.createElement("g", {
    id: "user_3_",
    "data-name": "user (3)",
    transform: "translate(1268.208 22.172)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_70",
    "data-name": "Path 70",
    d: "M90.976,7.93a3.806,3.806,0,0,0,2.789-1.162,3.847,3.847,0,0,0,1.155-2.8,3.847,3.847,0,0,0-1.155-2.8,3.928,3.928,0,0,0-5.577,0,3.847,3.847,0,0,0-1.155,2.8,3.847,3.847,0,0,0,1.156,2.8A3.807,3.807,0,0,0,90.976,7.93Zm0,0",
    transform: "translate(-84.233 0)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_71",
    "data-name": "Path 71",
    d: "M13.659,252.023a9.823,9.823,0,0,0-.133-1.04,8.218,8.218,0,0,0-.255-1.046,5.174,5.174,0,0,0-.429-.975,3.68,3.68,0,0,0-.646-.845,2.848,2.848,0,0,0-.928-.585,3.2,3.2,0,0,0-1.185-.215,1.2,1.2,0,0,0-.642.273c-.193.126-.418.272-.669.433a3.829,3.829,0,0,1-.866.383,3.353,3.353,0,0,1-2.118,0,3.821,3.821,0,0,1-.865-.383c-.249-.16-.474-.305-.67-.433a1.2,1.2,0,0,0-.642-.273,3.2,3.2,0,0,0-1.185.215,2.845,2.845,0,0,0-.929.585,3.679,3.679,0,0,0-.646.845,5.184,5.184,0,0,0-.429.976,8.236,8.236,0,0,0-.255,1.046,9.788,9.788,0,0,0-.133,1.041c-.022.315-.033.642-.033.972a2.738,2.738,0,0,0,.809,2.068,2.908,2.908,0,0,0,2.086.763h7.9a2.908,2.908,0,0,0,2.086-.763A2.737,2.737,0,0,0,13.692,253c0-.332-.011-.659-.033-.972Zm0,0",
    transform: "translate(0 -239.415)",
    fill: "#fff"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLoggedUserIcon);
export default __webpack_public_path__ + "static/media/loggedUserIcon.3789b778bf3952ac59539d825cd7f651.svg";
export { ForwardRef as ReactComponent };